import { render, staticRenderFns } from "./CollectionEventPopup.vue?vue&type=template&id=55708925&"
import script from "./CollectionEventPopup.vue?vue&type=script&lang=ts&"
export * from "./CollectionEventPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionEventPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports